import React from 'react'
import { NumericFormat } from 'react-number-format'
import { PRICE_FORMAT, STRING_EMPTY } from 'utils/constants'

const PriceInput = (props) => {
  const { inputRef, onChange, ...other } = props

  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value !== STRING_EMPTY ? Number(values.value) : STRING_EMPTY
          }
        })
      }}
      {...PRICE_FORMAT}
    />
  )
}

export default PriceInput
